import { Global, css } from '@emotion/core';
import React from 'react';
import styled from '../../styled';

const LogosWrapper = styled('div')`
  padding: 60px 24px;
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;

  @media (max-width: 960px) {
    max-width: 100%;
  }
`;

const marqueeStyles = css`
  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  @keyframes marqueeReverse {
    0% {
      transform: translateX(-50%);
    }
    100% {
      transform: translateX(0);
    }
  }
`;

const MarqueeRow = styled('div')<{ reverse?: boolean }>`
  display: flex;
  gap: 40px;
  width: fit-content;
  animation: ${(p) => (p.reverse ? 'marqueeReverse' : 'marquee')} 60s linear
    infinite;

  @media (max-width: 960px) {
    gap: 32px;
  }
`;

const LogosContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 40px;
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    transparent 8%,
    black 15%,
    black 85%,
    transparent 92%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    transparent 8%,
    black 15%,
    black 85%,
    transparent 92%,
    transparent 100%
  );

  @media (max-width: 960px) {
    gap: 32px;
    mask-image: linear-gradient(
      to right,
      transparent 0%,
      transparent 5%,
      black 12%,
      black 88%,
      transparent 95%,
      transparent 100%
    );
    -webkit-mask-image: linear-gradient(
      to right,
      transparent 0%,
      transparent 5%,
      black 12%,
      black 88%,
      transparent 95%,
      transparent 100%
    );
  }

  @media (max-width: 600px) {
    mask-image: linear-gradient(
      to right,
      transparent 0%,
      transparent 3%,
      black 10%,
      black 90%,
      transparent 97%,
      transparent 100%
    );
    -webkit-mask-image: linear-gradient(
      to right,
      transparent 0%,
      transparent 3%,
      black 10%,
      black 90%,
      transparent 97%,
      transparent 100%
    );
  }
`;

const LOGO_HEIGHT = 36;

const Logo = styled('img')`
  height: ${LOGO_HEIGHT}px;
  opacity: 0.6;
  filter: grayscale(100%);
  transition: opacity 0.2s, filter 0.2s;
  flex-shrink: 0;

  @media (max-width: 960px) {
    height: 32px;
  }

  @media (max-width: 600px) {
    height: 28px;
  }
`;

const topLogos = [
  { src: '/images/logos/us-weekly.png', alt: 'US Weekly' },
  { src: '/images/logos/business-insider.svg', alt: 'Business Insider' },
  { src: '/images/logos/theskimm.svg', alt: 'theSkimm' },
  { src: '/images/logos/usa-today.svg', alt: 'USA Today' },
  { src: '/images/logos/outside-inc.svg', alt: 'Outside Inc' },
  { src: '/images/logos/mcclatchy-media.svg', alt: 'McClatchy Media' },
  { src: '/images/logos/inst.svg', alt: '' },
  { src: '/images/logos/bauer.svg', alt: '' }
];

const bottomLogos = [
  { src: '/images/logos/katie-couric-media.svg', alt: 'Katie Couric Media' },
  { src: '/images/logos/t-and-l.png', alt: '' },
  { src: '/images/logos/purewow.svg', alt: 'PureWow' },
  {
    src: '/images/logos/everyday-health-group.png',
    alt: 'Everyday Health Group'
  },
  { src: '/images/logos/fw.svg', alt: '' },
  { src: '/images/logos/linus-tech-tips.png', alt: 'Linus Media Group' },
  { src: '/images/logos/a360-media.svg', alt: 'A360 Media' },
  { src: '/images/logos/news-uk.svg', alt: 'News UK' },
  { src: '/images/logos/ziff-davis.svg', alt: 'Ziff Davis' },
  { src: '/images/logos/recurrent-ventures.svg', alt: 'Recurrent Ventures' }
];

export const LogosSection = () => {
  // Duplicate logos array to create seamless infinite scroll
  const duplicatedLogosTop = [...topLogos, ...topLogos];
  const duplicatedLogosBottom = [...bottomLogos, ...bottomLogos];

  return (
    <>
      <Global styles={marqueeStyles} />
      <LogosWrapper>
        <LogosContainer>
          <MarqueeRow>
            {duplicatedLogosTop.map((logo, index) => (
              <Logo key={`row1-${index}`} src={logo.src} alt={logo.alt} />
            ))}
          </MarqueeRow>
          <MarqueeRow reverse>
            {duplicatedLogosBottom.map((logo, index) => (
              <Logo key={`row2-${index}`} src={logo.src} alt={logo.alt} />
            ))}
          </MarqueeRow>
        </LogosContainer>
      </LogosWrapper>
    </>
  );
};
